module.exports = __webpack_public_path__ + "06fe35434e431d11acf63bd320197bf9.png";